import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

function Box({
  visibleBox = true,
  limitWidth = true,
  minHeight = true,
  children,
  onBack,
}) {
  return (
    <div
      className={cn(
        'c-signup-flow__inner flex-column relative inline-flex w-full justify-center shadow-subtle sm:px-16 lg:px-64',
        onBack ? 'sm:pb-[24px] sm:pt-[60px] lg:pt-[54px]' : 'sm:py-0 lg:py-32',
        {
          'c-signup-flow__inner--boxless': !visibleBox,
          'max-w-576': limitWidth,
          'md:min-height-[450px]': minHeight,
        },
      )}
    >
      <div className="flex-column md:min-width-[450px] w-full justify-center">
        {onBack && (
          <button
            data-uid="back_button"
            className="c-signup-flow__back absolute top-[18px] sm:left-[16px] lg:left-[60px]"
            onClick={() => onBack()}
            aria-label="Back"
          />
        )}
        {children}
      </div>
    </div>
  )
}

Box.propTypes = {
  visibleBox: PropTypes.bool,
  limitWidth: PropTypes.bool,
  minHeight: PropTypes.bool,
  children: PropTypes.any.isRequired,
  onBack: PropTypes.func,
}

export default Box
